module.exports = __webpack_public_path__ + "static/bg_partnership-c9e59bf45d1dd1731821c3ce83c5bf6e.png";